export default __webpack_public_path__ + "static/media/ted2.0c064150.jpg";